import { getFormatDiscount } from './functions/getDiscountFormat';
import { getRandomInt } from './functions/getRandomInt';
import { handleWithMileDot } from './functions/handleWithMileDot';
import { toCurrencyPrototype } from './functions/toCurrency';
Number.prototype.toCurrency = toCurrencyPrototype;
Number.prototype.handleWithMileDot = handleWithMileDot;
Number.prototype.getDiscountFormat = getFormatDiscount;
Number.getRandomInt = getRandomInt;
export default {};
//# sourceMappingURL=index.js.map